import { render, staticRenderFns } from "./sideBar.html?vue&type=template&id=59fbd67a&scoped=true&external"
import script from "./sideBar.vue?vue&type=script&lang=ts"
export * from "./sideBar.vue?vue&type=script&lang=ts"
import style0 from "./sideBar.scss?vue&type=style&index=0&id=59fbd67a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fbd67a",
  null
  
)

export default component.exports